import { KEEP_ASSIGNEE, ROUTING_RULE_TYPES } from '../constants/RoutingTypes';
import { getRotationMethod, getType } from '../operators/routingRulesGetters';
import { buildRoutingRulesFromType } from '../utils/buildRoutingRulesFromType';
import { RoutingTypeLabel } from './RoutingTypeLabel';
import RuleBox from './RuleBox';
import SelectAssignmentGroup from './SelectAssignmentGroup';
import { jsx as _jsx } from "react/jsx-runtime";
const RoutingRulesSelectRow = ({
  aiChatbotId,
  disabled,
  disableKeepAssigneeOption,
  overrides = {},
  routingRules,
  showAnyUserOption,
  showKeepAssigneeOption,
  showTeamsOnlyOption,
  showUnassignedOption,
  showOwnerOption,
  onOpenChange,
  onRuleUpdate,
  FormControl,
  routingSource,
  workSpace,
  isUngatedForHelpDeskRoutingScopeFiltering
}) => {
  const onRoutingTypeChange = evt => {
    const rotationMethod = getRotationMethod(routingRules) || undefined;
    onRuleUpdate(evt.target.value === KEEP_ASSIGNEE ? evt.target.value : buildRoutingRulesFromType(evt.target.value, {
      aiChatbotId,
      rotationMethod
    }));
  };
  let currentGroup = getType(routingRules);
  if (!currentGroup) {
    currentGroup = showKeepAssigneeOption ? KEEP_ASSIGNEE : ROUTING_RULE_TYPES.UNASSIGNED;
  }
  return /*#__PURE__*/_jsx(RuleBox, {
    FormControl: FormControl,
    label: overrides.label || /*#__PURE__*/_jsx(RoutingTypeLabel, {
      disabled: disabled,
      isUngatedForHelpDeskRoutingScopeFiltering: isUngatedForHelpDeskRoutingScopeFiltering,
      routingSource: routingSource,
      workSpace: workSpace
    }),
    children: /*#__PURE__*/_jsx(SelectAssignmentGroup, {
      aiChatbotId: aiChatbotId,
      currentGroup: currentGroup,
      disableKeepAssignee: disableKeepAssigneeOption,
      menuWidth: overrides.menuWidth,
      onChange: onRoutingTypeChange,
      onOpenChange: onOpenChange,
      overrides: overrides.options,
      showAnyUser: showAnyUserOption,
      showKeepAssignee: showKeepAssigneeOption,
      showTeamsOnly: showTeamsOnlyOption,
      showUnassigned: showUnassignedOption,
      showOwner: showOwnerOption,
      routingSource: routingSource,
      disabled: disabled
    })
  });
};
RoutingRulesSelectRow.displayName = 'RoutingRulesSelectRow';
export default RoutingRulesSelectRow;